<template>
  <v-form v-model="isValid">
    <v-text-field label="Email" v-model="email" type="text" :rules="emailRules" @keyup.enter.native="submit"
                  required></v-text-field>
    <v-text-field
      label="Password"
      v-model="password"
      :type="showPass ? 'text' : 'password'"
      :rules="passwordRules"
      :append-icon="showPass ? 'mdi-eye' : 'mdi-eye-off'"
      @click:append="showPass = !showPass"
      @keyup.enter.native="submit"
      required
    ></v-text-field>
    <div>
      <v-btn large @click="submit" block color="primary" class="mb-2" :disabled="!isValid">Login</v-btn>
    </div>
  </v-form>
</template>

<script>
  import {nonEmptyField, validEmail, validPassword} from "../../helpers/helpers";

  export default {
    name: "login",
    data() {
      return {
        showPass: false,
        email: '',
        password: '',
        emailRules: [v => nonEmptyField(v, 'email'), v => validEmail(v)],
        passwordRules: [v => nonEmptyField(v, 'password'), v => validPassword(v)],
        isValid: false,
      }
    },
    methods: {
      submit() {
        if (this.isValid) {
          const payload = {
            email: this.email,
            password: this.password
          };
          this.$store.dispatch('login', payload);
        }
      },

    }
  }
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/Login/login.vue